import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { Loading } from '../../../../../../common/loading'
import { Notification } from '../../../../../../common/notification'
import { mapViewBy } from '../../constant'
import { selectCompareVal, selectData, selectLoading } from '../../store/slice'
import ChartRatioComparison from './ChartRatioComparison'
import ChartRatioComparisonExport from './ChartRatioComparisonExport'
import TableRatioComparison from './TableRatioComparison'

const RatioComparison = ({ isDynamicReport, settingDynamic = {}, viewBy }) => {
  const loading = useSelector(selectLoading)
  const data = useSelector(selectData)
  const compareValStore = useSelector(selectCompareVal)
  const { compareBetweenRatio: compareValDyn } = settingDynamic
  const compareVal = isDynamicReport ? compareValDyn : compareValStore
  const defaultData = data[compareVal]?.defaultIndustry
  const compareData = data[compareVal]?.comparingIndustry
  const year = defaultData?.ratioYear || compareData?.ratioYear || ''

  return (
    <div style={{ position: 'relative' }}>
      <Element style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>
        <Translate
          value="companyAnalysis.industryAnalysis.RATIO_COMPARISON"
          year={year}
        />
      </Element>

      {loading ? (
        <div className="positionRelative" style={{ height: 350 }}>
          <Loading />
        </div>
      ) : (
        <div id="ratioComparisonChartId">
          <>
            {!defaultData?.ratio && !compareData?.ratio ? (
              <div style={{ height: 350 }}>
                <Notification />
              </div>
            ) : (
              <>
                {viewBy === mapViewBy.chart.value ? (
                  <>
                    {isDynamicReport ? (
                      <ChartRatioComparisonExport
                        settingDynamic={settingDynamic}
                      />
                    ) : (
                      <ChartRatioComparison />
                    )}
                  </>
                ) : (
                  <TableRatioComparison
                    isDynamicReport={isDynamicReport}
                    settingDynamic={settingDynamic}
                    year={year}
                  />
                )}
              </>
            )}
          </>
        </div>
      )}
    </div>
  )
}

export default RatioComparison
